<template>
    <UploadFeedback />
    <CookieConsentModal />
    <PageHeader :show-nav="showNav" />
    <div id="content">
        <NotFound v-if="pageErrorStore.status === 404" />
        <Forbidden v-else-if="pageErrorStore.status === 403" />
        <router-view v-else :key="showNav ? $route.path : undefined" />
    </div>
    <PageFooter />
</template>

<script>
import { computed } from "vue";
import _debounce from "lodash/debounce";
import PageHeader from "js/layout/PageHeader";
import PageFooter from "js/layout/PageFooter";
import UploadFeedback from "js/components/common/UploadFeedback";
import NotFound from "js/pages/NotFound";
import Forbidden from "js/pages/Forbidden";
import CookieConsentModal from "js/components/modals/CookieConsentModal.vue";
import { usePageErrorStore } from "js/stores/pageErrorStore.js";
import { useUserStore } from "js/stores/userStore.js";

import "ol/ol.css";

export default {
    name: "App",
    components: {
        PageHeader,
        PageFooter,
        UploadFeedback,
        NotFound,
        Forbidden,
        CookieConsentModal,
    },
    provide() {
        return {
            screenWidth: computed(() => this.width),
        };
    },
    data() {
        return {
            store: undefined,
            width: 0,
            pageErrorStore: usePageErrorStore(),
            userStore: useUserStore(),
        };
    },
    computed: {
        showNav() {
            return this.userStore.isLoggedIn;
        },
    },
    created() {
        this.onResize();

        window.addEventListener("resize", this.onResize);
    },
    beforeUnmount() {
        window.removeEventListener("resize", this.onResize);
    },
    methods: {
        onResize: _debounce(function () {
            this.width = window.innerWidth;
        }, 200),
    },
};
</script>
